import React from "react";
import "./BalanceSheetStyle.css";

function BalanceSheetItem(props) {
  let valueClasses = "value";
  let thresholdClass = "";
  let label = props.label;
  if (props.value === 0 || props.value === undefined) {
    return <></>;
  }
  if (props.threshold !== undefined) {
    thresholdClass = props.value < props.threshold ? " underThreshold" : "";
  }
  let totalClass =
    label.toUpperCase().includes("TOTAL") === true ? " total" : "";
  valueClasses += thresholdClass;
  valueClasses += totalClass;
  return (
    <tr>
      <td className={"label " + valueClasses}>{props.label}</td>
      <td className={valueClasses}>{props.value}</td>
    </tr>
  );
}

export default BalanceSheetItem;
